module.exports = __webpack_public_path__ + "img/QRcode.1d5cedda.png";